"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');

var uuid = require('uuid');
/**
* Manage anonymous user profile
* @extends SoulModule
*/


var Incognito =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Incognito, _SoulModule);

  function Incognito() {
    _classCallCheck(this, Incognito);

    return _possibleConstructorReturn(this, _getPrototypeOf(Incognito).apply(this, arguments));
  }

  _createClass(Incognito, [{
    key: "get",

    /**
     * Get incognito user profile
     * @param {string} id 
     * @param {Function} callback 
     * @return {Promise}
     * @soulsdk soul.incognito.get
     */
    value: function get(id, callback) {
      return this.api.get(function (res) {
        return res;
      }, 'me/incognito', {
        anonymousUser: id,
        apiKey: this.apiKey
      }, callback);
    }
    /**
     * Creates new incognito user by patching 'me/incognito
     * @param {Function} callback 
     * @return {Promise}
     * @soulsdk soul.incognito.create
     */

  }, {
    key: "create",
    value: function create(callback) {
      var _this = this;

      return this.api.patch(function (res) {
        _this.storage.set('anonymous_user', res.me.id);

        return res;
      }, 'me/incognito', {
        apiKey: this.apiKey
      }, callback);
    }
    /**
     * Updates already created incognito user profile with passed parameters
     * @param {Object} parameters 
     * @param {Function} callback 
     * @return {Promise}
     * @soulsdk soul.incognito.update
     */

  }, {
    key: "update",
    value: function update(parameters, callback) {
      var anonymousUser = this.storage.get('anonymous_user');

      if (anonymousUser) {
        return this.api.patch(function (res) {
          return res;
        }, 'me/incognito', {
          anonymousUser: anonymousUser,
          parameters: parameters,
          apiKey: this.apiKey
        }, callback);
      }

      return null;
    }
    /**
     * Patching recommendations filter
     * 
     * @param {Object} filter 
     * @param {Function} callback 
     * @return {Promise}
     * @soulsdk soul.incognito.updateRecommendationsFilter
     */

  }, {
    key: "updateRecommendationsFilter",
    value: function updateRecommendationsFilter(filter) {
      var anonymousUser = this.storage.get('anonymous_user');

      if (anonymousUser) {
        return this.api.patch('users/recommendations/incognito/filter', {
          filter: filter,
          anonymousUser: anonymousUser,
          apiKey: this.apiKey
        });
      }

      return null;
    }
    /**
     * Fetching recommendations list from patched filter
     * @param {Object} parameters
     * @return {Promise}
     * @soulsdk soul.incognito.getRecommendations
     */

  }, {
    key: "getRecommendations",
    value: function getRecommendations(parameters) {
      var viewingSession = parameters.viewingSession,
          uniqueToken = parameters.uniqueToken;
      var anonymousUser = this.storage.get('anonymous_user');
      viewingSession = (viewingSession || this.storage.get('viewingSession') || uuid()).toString();
      uniqueToken = (uniqueToken || this.storage.get('uniqueToken') || uuid()).toString();
      this.storage.set('viewingSession', viewingSession);
      this.storage.set('uniqueToken', uniqueToken);

      if (anonymousUser) {
        return this.api.get('users/recommendations/incognito/list', {
          anonymousUser: anonymousUser,
          apiKey: this.apiKey,
          viewingSession: viewingSession,
          uniqueToken: uniqueToken
        });
      }

      return null;
    }
    /**
     * Checks if there is saved incognito user id
     * 
     * @return {Object}
     * @soulsdk soul.incognito.checkSession
     */

  }, {
    key: "checkSession",
    value: function checkSession() {
      var anonymousUser = this.storage.get('anonymous_user');

      if (anonymousUser) {
        return this.api.get(function (res) {
          return res;
        }, 'me/incognito', {
          anonymousUser: anonymousUser,
          apiKey: this.apiKey
        });
      }

      return null;
    }
  }]);

  return Incognito;
}(SoulModule);

module.exports = Incognito;